import { Controller } from "@hotwired/stimulus";

// 接続された要素にフォーカスを当てる。ブラウザの autofocus と異なり、
// preventScroll: true でフォーカスに伴う自動スクロールを抑止する。
// Stimulus の connect() は Turbo Frame 更新時にも再実行されるため、
// account-type-switcher による個人/法人切替後も先頭フィールドにフォーカスが当たる。
export class FocusNoScrollController extends Controller {
  connect() {
    // レイアウト確定後にフォーカスを当てるため次フレームに遅延（要素挿入直後の
    // スクロール位置確定タイミングを跨ぐ）
    requestAnimationFrame(() => {
      this.element.focus({ preventScroll: true });
    });
  }
}
